import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

const TermsOfService: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="legal-back">&larr; Back to VizDay</Link>
        <h1>Terms of Service</h1>
        <p className="legal-meta">Last updated: March 15, 2026</p>

        <p>
          These Terms of Service ("Terms") govern your use of VizDay ("Service"), operated by
          VizDay ("we", "us", "our"). By accessing or using VizDay, you agree to these Terms.
        </p>

        <h2>1. Account Terms</h2>
        <ul>
          <li>You must be at least 13 years old to use VizDay.</li>
          <li>You are responsible for maintaining the security of your account and password.</li>
          <li>You are responsible for all activity that occurs under your account.</li>
          <li>You must provide accurate and complete information when creating an account.</li>
        </ul>

        <h2>2. Subscriptions & Billing</h2>
        <ul>
          <li>VizDay features may be provided free of charge or as part of a paid subscription. Where a subscription is offered, the price and terms are shown in the app before you purchase.</li>
          <li>You may cancel a subscription at any time through the provider where you subscribed. Cancelling never removes access to features that are free at the time.</li>
          <li>We will not begin charging for a feature you already have without telling you first.</li>
          <li>Refunds are handled on a case-by-case basis. Contact us at arnold@vizday.com.</li>
        </ul>

        <h2>3. AI-Generated Content</h2>
        <ul>
          <li>VizDay uses artificial intelligence to provide suggestions, itineraries, briefings, and other content.</li>
          <li>AI-generated content is provided for informational purposes only and should not be relied upon as professional advice.</li>
          <li>We do not guarantee the accuracy, completeness, or suitability of AI-generated content.</li>
          <li>You are responsible for verifying any information before acting on it.</li>
        </ul>

        <h2>4. User Content</h2>
        <ul>
          <li>You retain ownership of all content you create in VizDay (events, itineraries, family data).</li>
          <li>You grant us a limited license to store, process, and display your content to provide the Service.</li>
          <li>You must not upload content that is illegal, harmful, or violates the rights of others.</li>
        </ul>

        <h2>5. Calendar & Third-Party Integrations</h2>
        <ul>
          <li>VizDay connects to Google Calendar, Microsoft Calendar, and other services on your behalf.</li>
          <li>We access only the calendar data you authorize and use it solely to provide the Service.</li>
          <li>You may revoke access at any time through your account settings or the third-party provider.</li>
        </ul>

        <h2>6. Acceptable Use</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Use the Service for any unlawful purpose.</li>
          <li>Attempt to gain unauthorized access to the Service or its systems.</li>
          <li>Interfere with or disrupt the Service.</li>
          <li>Scrape, crawl, or otherwise extract data from the Service without permission.</li>
        </ul>

        <h2>7. Termination</h2>
        <ul>
          <li>You may delete your account at any time from Settings.</li>
          <li>We may suspend or terminate accounts that violate these Terms.</li>
          <li>Upon termination, your data will be deleted in accordance with our Privacy Policy.</li>
        </ul>

        <h2>8. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, VizDay shall not be liable for any indirect,
          incidental, special, consequential, or punitive damages, or any loss of profits or
          revenues, whether incurred directly or indirectly, or any loss of data, use, or goodwill.
        </p>

        <h2>9. License Grant (EULA)</h2>
        <p>
          Subject to these Terms, we grant you a limited, non-exclusive, non-transferable, revocable license
          to access and use VizDay for your personal, non-commercial family scheduling and travel planning purposes.
          You may not copy, modify, distribute, sell, or lease any part of the Service, nor may you reverse
          engineer or attempt to extract the source code of any software used to provide the Service.
        </p>

        <h2>10. Governing Law</h2>
        <p>
          These Terms are governed by the laws of the State of California, without regard to conflict of law provisions.
          Any disputes arising from these Terms shall be resolved in the courts of California.
        </p>

        <h2>11. Changes to Terms</h2>
        <p>
          We may update these Terms from time to time. We will notify you of material changes
          via email or in-app notification. Continued use of the Service after changes constitutes
          acceptance of the new Terms.
        </p>

        <h2>12. Contact</h2>
        <p>
          Questions about these Terms? Contact us at{' '}
          <a href="mailto:arnold@vizday.com">arnold@vizday.com</a>.
        </p>

        <div className="legal-links">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/delete-account">Delete your account</Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
